import { render, staticRenderFns } from "./TrendingApps.vue?vue&type=template&id=470e1b78"
import script from "./TrendingApps.vue?vue&type=script&lang=js"
export * from "./TrendingApps.vue?vue&type=script&lang=js"
import style0 from "./TrendingApps.vue?vue&type=style&index=0&id=470e1b78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports